import { useParams } from "react-router-dom";
import { blogs } from "../data/blogs";
import SEO from "../components/common/SEO";
import PageNotFound from "./PageNotFound";
import BlogBanner from "../components/blogdetails/BlogBanner";
import BlogContent from "../components/blogdetails/BlogContent";
import RelatedBlogs from "../components/blogdetails/RelatedBlogs";
import CTASection from "../components/common/CTASection";

const BlogDetails = () => {
  const { slug } = useParams();

  const blog = blogs.find(
    (item) => item.slug === slug
  );

  if (!blog) {
    return <PageNotFound />;
  }

  return (
    <>
      <SEO
        title={`${blog.metaTitle || blog.title} | AZ Construction`}
        description={blog.metaDescription || blog.excerpt}
        url={`https://azconstruction.com/blogs/${blog.slug}`}
        image={blog.image}
        type="article"
      />
      <BlogBanner blog={blog} />

      <BlogContent blog={blog} />

      <RelatedBlogs currentBlog={blog} />

      <CTASection />
    </>
  );
};

export default BlogDetails;